<template>
  <div class="sidebar-resume-block">
    <button
      role="button"
      type="button"
      :class="[
        'sidebar-resume-block__title',
        { 'sidebar-resume-block__title--collapsable': collapsable },
      ]"
      @click="toggle_visible()"
    >
      <div class="sidebar-resume-block__title__text">
        {{ title }}
        <vb-icon
          v-if="info"
          :id="`sidebar-resume-block:${title}`"
          :ref="`sidebar-resume-block:${title}`"
          name="info"
          :size="16"
          :color="'#AAA'"
        />
        <b-popover
          v-if="info"
          :target="`sidebar-resume-block:${title}`"
          triggers="hover"
          placement="top"
        >
          <span v-html="info"></span>
        </b-popover>
      </div>
      <div
        v-if="Object.keys(title_content || {}).length > 0"
        class="sidebar-resume-block__title__text"
      >
        <vb-icon v-if="title_content.icon" v-bind="title_content.icon" />
        <div v-if="title_content.text" class="bold text-content">
          {{ title_content.text }}
        </div>
      </div>
      <vb-icon 
        v-if="collapsable" 
        name="chevron-down" 
        :class="`sidebar-resume-block__title__chevron--${visible ? 'visible' : 'hidden'}`" 
        :size="12"
      />
    </button>
    <hr />
    <b-collapse :visible="visible" role="tabpanel">
      <div class="sidebar-resume-block__body">
        <slot name="default"></slot>
      </div>
    </b-collapse>
    <hr v-if="$slots.footer" />
    <div class="sidebar-resume-block__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sidebar-resume-block',
    props: {
      title: {
        type: String,
        default: () => '',
      },
      info: {
        type: String,
        default: () => '',
      },
      title_content: {
        type: Object,
        default: () => ({}),
      },
      collapsable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        visible: !this.collapsable,
      };
    },
    methods: {
      toggle_visible() {
        if (!this.collapsable) {
          return;
        }
        this.visible = !this.visible;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .sidebar-resume-block {
    hr {
      padding: 0;
      margin: 0;
    }

    display: flex;
    flex-direction: column;

    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--primary);
      padding: 0;
      background-color: transparent;
      border: 0;
      margin-bottom: 5px;
      cursor: default;


      &--collapsable {
        cursor: pointer;
      }

      &__text {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      &__chevron{
        &--hidden {
          transition: $transition-base;
          transform: rotate(0deg);
        }
        &--visible {
          transition: $transition-base;
          transform: rotate(180deg);
        }
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 5px;
      padding: 15px 0;
    }

    &__footer {
      margin-top: 5px;
      width: 100%;
    }
  }
</style>
